/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { union, alias } from '@ember/object/computed';
import { service } from '@ember/service';
import GradingMethod from '@linc-technologies/linced-common/enums/grading-method';
import { byKeys } from '@linc-technologies/linced-common/utils/arrays';

export default class AssessmentController extends Controller {
  @service
  session;

  @service
  store;

  @alias('model.assessment')
  assessment;

  @alias('model.person')
  person;

  @alias('model.modules')
  modules;

  @computed(
    'model.grades.@each.{numericAwarded,numericScale,selectAwarded,multiSelectAwarded}',
    'modules.[]',
  )
  get latestGrades() {
    return this.modules.reduce((modules, module) => {
      modules[module.id] = this.findLatestGrade(module);
      return modules;
    }, {});
  }

  GradingMethod = GradingMethod;

  @union('model.posts', 'model.assessmentPosts')
  allPosts;

  @action
  refreshGrades() {
    this.get('model.grades').update();
  }

  findLatestGrade(module) {
    let moduleGrades = this.get('model.grades').filter(
      (grade) => grade.module.id === module.id,
    );
    if (moduleGrades && moduleGrades.length) {
      return moduleGrades.sort(byKeys('createTime')).at(-1);
    }

    return null;
  }
}
